import React from "react";

import Styles from "./TextInputWrapper.styles";
import { TextInputWrapperProps as Props } from "./TextInputWrapper.types";

import InputSpinnerSVG from "../../../../public/assets/images/input-spinner.svg";

const TextInputWrapper: React.FC<Props> = props => {
  const { children, className } = props;
  const { showSpinner } = props;

  return (
    <Styles className={`TextInputWrapper ${className}`}>
      {children}
      {showSpinner ? (
        <div className="TextInputWrapper__input-spinner">
          <InputSpinnerSVG />
        </div>
      ) : null}
    </Styles>
  );
};

TextInputWrapper.defaultProps = {};

export default TextInputWrapper;
